import { FileSliders } from "lucide-react"
import { useNavigate } from "react-router"

interface PptSessionLinkCardProps {
  title: string
  sessionUrl: string
}

export default function PptSessionLinkCard({
  title,
  sessionUrl
}: PptSessionLinkCardProps) {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate(sessionUrl)}
      className="flex items-center gap-3 px-4 py-3 rounded-lg border border-primary/20 bg-primary/5 hover:bg-primary/10 transition-colors cursor-pointer text-left w-full max-w-sm"
    >
      <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
        <FileSliders className="text-primary" size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-genesis dark:text-white truncate">
          {title || "Presentation"}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Open Presentation
        </p>
      </div>
    </button>
  )
}
